import RtReconciliationSearchUnmatchedRequestBase from './base/RtReconciliationSearchUnmatchedRequestBase';

/**
 * @class RtReconciliationSearchUnmatchedRequest
 * @extends RtReconciliationSearchUnmatchedRequestBase
 */
class RtReconciliationSearchUnmatchedRequest extends RtReconciliationSearchUnmatchedRequestBase {

}

export default RtReconciliationSearchUnmatchedRequest;
